import "./styles.css";

import { ReactComponent as PenEdit } from "../../../../../../assets/svg/icons/penEdit.svg";
import { useTranslation } from "react-i18next";

type TitleTableProps = {
  title: string;
  handleClick: () => void;
  onlyRead?: boolean,
};

export function TitleTable({ title, handleClick, onlyRead = false }: TitleTableProps) {
  const { t } = useTranslation();

  return (
    <section className="containerTable_container--title">
      <h2>{t(title === "MALE" ? "weightCategories.maleEvolution" : "weightCategories.femaleEvolution")}</h2>
      {!onlyRead &&
        <button onClick={handleClick}>
          <PenEdit />
        </button>
      }
    </section>
  );
}
